import { render, staticRenderFns } from "./version-grid.vue?vue&type=template&id=138193f6"
import script from "./version-grid.vue?vue&type=script&lang=js"
export * from "./version-grid.vue?vue&type=script&lang=js"
import style0 from "./version-grid.vue?vue&type=style&index=0&id=138193f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports